<template>
  <div>
    <a-card title="手续费规则管理" style="margin: 20px">
      <!-- 筛选区域 -->
      <div class="selectBox">
        <div class="item">
          <span>规则编号</span>
          <a-input v-model.trim="paramsData.feeNo" allow-clear placeholder="请输入规则编号"/>
        </div>
        <div class="item">
          <span>规则名称</span>
          <a-input v-model.trim="paramsData.feeName" allow-clear placeholder="请输入规则名称"/>
        </div>
        <div class="item">
          <span>规则类型</span>
          <a-select v-model="paramsData.feeType" allow-clear placeholder="请选择规则类型" style="width: 200px">
            <a-select-option value="1">定额</a-select-option>
            <a-select-option value="2">按比例</a-select-option>
            <a-select-option value="3">分段</a-select-option>
            <a-select-option value="4">按比例按天</a-select-option>
          </a-select>
        </div>
        <div class="item">
          <a-button type="primary" @click="handleQuery" v-if="$authority('feeRuleQuery')">查询</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
        </div>
      </div>

      <!-- 表格部分 -->
      <div class="tableBox">
        <div class="handleBtn">
          <a-button type="primary" @click="addBtn" v-if="$authority('feeRuleAdd')">新增</a-button>
          <a-button type="primary" @click="handleQuery">刷新</a-button>
        </div>
        <div class="tableBody">
          <a-table
              :columns="columns"
              :data-source="tableData"
              :pagination="false"
              :row-key="record => record.id"
              :loading="tableLoading"
          >
            <template slot="feeType" slot-scope="text">
              <a-tag :color="feeTypeColor(text)">{{ feeTypeText(text) }}</a-tag>
            </template>
            <template slot="feeAmount" slot-scope="text, record">
              <template v-if="record.feeType === '1'">
                {{ record.fixedFee != null ? record.fixedFee : '-' }}
              </template>
              <template v-else-if="record.feeType === '2'">
                {{ record.feeProportion != null ? (record.feeProportion * 100) + '%' : '-' }}
                <template v-if="record.feeMin != null || record.feeMax != null">
                  ({{ record.feeMin != null ? '下限:' + record.feeMin : '' }}
                  {{ record.feeMax != null ? '上限:' + record.feeMax : '' }})
                </template>
              </template>
              <template v-else-if="record.feeType === '3'">
                分段({{ (record.feeFdRules || []).length }}条)
              </template>
              <template v-else-if="record.feeType === '4'">
                {{ record.feeProportion != null ? (record.feeProportion * 100) + '%/天' : '-' }}
              </template>
              <template v-else>-</template>
            </template>
            <template slot="action" slot-scope="text, record">
              <a-button-group size="small">
                <a-button v-if="$authority('feeRuleView')" icon="eye" style="color: #1890ff;" type="link" @click="viewBtn(record)">查看</a-button>
                <a-button v-if="$authority('feeRuleEdit')" icon="edit" style="color: #52c41a;" type="link" @click="editBtn(record)">编辑</a-button>
                <a-popconfirm v-if="$authority('feeRuleDel')" title="确认删除该手续费规则？" @confirm="handleDelete(record)">
                  <a-button icon="delete" style="color: #ff4d4f;" type="link">删除</a-button>
                </a-popconfirm>
              </a-button-group>
            </template>
          </a-table>
        </div>
      </div>

      <!-- 分页部分 -->
      <div class="pagination-wrapper">
        <LcfsPagination :fn="getTableData" :page-no.sync="pagination.pageNo" :page-size.sync="pagination.pageSize" :total="pagination.total"/>
      </div>
    </a-card>

    <!-- 查看详情弹窗 -->
    <a-modal
        v-model="viewModalVisible"
        :destroyOnClose="true"
        :footer="null"
        title="手续费规则详情"
        width="65%"
    >
      <div class="detailBox">
        <a-descriptions :column="2" bordered size="small">
          <a-descriptions-item label="规则编号">{{ viewData.feeNo || '-' }}</a-descriptions-item>
          <a-descriptions-item label="规则名称">{{ viewData.feeName || '-' }}</a-descriptions-item>
          <a-descriptions-item label="规则类型">
            <a-tag :color="feeTypeColor(viewData.feeType)">{{ feeTypeText(viewData.feeType) }}</a-tag>
          </a-descriptions-item>
          <a-descriptions-item label="备注">{{ viewData.note || '-' }}</a-descriptions-item>
          <a-descriptions-item v-if="viewData.feeType === '1'" label="定额费用">{{ viewData.fixedFee != null ? viewData.fixedFee : '-' }}</a-descriptions-item>
          <template v-if="viewData.feeType === '2'">
            <a-descriptions-item label="比例">{{ viewData.feeProportion != null ? (viewData.feeProportion * 100) + '%' : '-' }}</a-descriptions-item>
            <a-descriptions-item label="费用下限">{{ viewData.feeMin != null ? viewData.feeMin : '-' }}</a-descriptions-item>
            <a-descriptions-item label="费用上限">{{ viewData.feeMax != null ? viewData.feeMax : '-' }}</a-descriptions-item>
          </template>
          <template v-if="viewData.feeType === '4'">
            <a-descriptions-item label="比例">{{ viewData.feeProportion != null ? (viewData.feeProportion * 100) + '%/天' : '-' }}</a-descriptions-item>
          </template>
          <a-descriptions-item label="创建时间">{{ viewData.createTime || '-' }}</a-descriptions-item>
          <a-descriptions-item label="创建人">{{ viewData.creater || '-' }}</a-descriptions-item>
          <a-descriptions-item v-if="viewData.updateTime" label="更新时间">{{ viewData.updateTime }}</a-descriptions-item>
          <a-descriptions-item v-if="viewData.updater" label="更新人">{{ viewData.updater }}</a-descriptions-item>
        </a-descriptions>

        <!-- 分段规则明细 -->
        <a-divider v-if="viewData.feeType === '3'">分段规则明细</a-divider>
        <a-table
            v-if="viewData.feeType === '3'"
            :columns="viewFdRuleColumns"
            :data-source="viewData.feeFdRules || []"
            :pagination="false"
            row-key="id"
            size="small"
            bordered
        >
          <template slot="fdFeeType" slot-scope="text">
            <a-tag :color="text === '11' ? 'blue' : 'purple'">{{ text === '11' ? '定额分段' : '按比例分段' }}</a-tag>
          </template>
          <template slot="amountRange" slot-scope="text, record">
            {{ record.tradeAmountMin != null ? '大于' + record.tradeAmountMin : '不限' }}
            ~
            {{ record.tradeAmountMax != null ? '小于等于' + record.tradeAmountMax : '不限' }}
          </template>
          <template slot="fdAmount" slot-scope="text, record">
            <template v-if="record.feeType === '11'">
              {{ record.fixedFee != null ? record.fixedFee : '-' }}
            </template>
            <template v-else-if="record.feeType === '21'">
              {{ record.feeProportion != null ? (record.feeProportion * 100) + '%' : '-' }}
              <template v-if="record.feeMin != null || record.feeMax != null">
                ({{ record.feeMin != null ? '下限:' + record.feeMin : '' }}
                {{ record.feeMax != null ? '上限:' + record.feeMax : '' }})
              </template>
            </template>
          </template>
        </a-table>
      </div>

      <template #footer>
        <a-button @click="viewModalVisible = false">关闭</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import LcfsPagination from "@/view/components/LcfsPagination.vue";

export default {
  name: 'FeeRule',
  components: {LcfsPagination},
  data() {
    return {
      tableLoading: false,
      pagination: {pageNo: 1, pageSize: 10, total: 0},
      tableData: [],
      columns: [
        {
          title: "No",
          customRender: (text, record, index) => `${(this.pagination.pageNo - 1) * this.pagination.pageSize + (index + 1)}`,
          align: "center",
          width: 50
        },
        {
          title: "规则编号",
          dataIndex: "feeNo",
          align: "center",
          width: 130
        },
        {
          title: "规则名称",
          dataIndex: "feeName",
          align: "center",
          width: 150
        },
        {
          title: "规则类型",
          dataIndex: "feeType",
          align: "center",
          width: 90,
          scopedSlots: {customRender: 'feeType'}
        },
        {
          title: "费用/比例",
          dataIndex: "feeAmount",
          align: "center",
          width: 200,
          scopedSlots: {customRender: 'feeAmount'}
        },
        {
          title: "备注",
          dataIndex: "note",
          align: "center",
          width: 150,
          customRender: (text) => text || '-'
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          align: "center",
          width: 150,
          customRender: (text) => text || '-'
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "center",
          scopedSlots: {customRender: 'action'}
        }
      ],
      paramsData: {
        feeNo: "",
        feeName: "",
        feeType: undefined,
      },

      // 查看弹窗
      viewModalVisible: false,
      viewData: {},
      viewFdRuleColumns: [
        {title: '分段类型', dataIndex: 'feeType', align: 'center', width: 80, scopedSlots: {customRender: 'fdFeeType'}},
        {title: '金额范围', dataIndex: 'amountRange', align: 'center', scopedSlots: {customRender: 'amountRange'}},
        {title: '费用/比例', dataIndex: 'fdAmount', align: 'center', scopedSlots: {customRender: 'fdAmount'}},
        {title: '备注', dataIndex: 'note', align: 'center', customRender: (text) => text || '-'},
      ],
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    feeTypeText(type) {
      const map = {'1': '定额', '2': '按比例', '3': '分段', '4': '按比例按天'};
      return map[type] || type || '-';
    },
    feeTypeColor(type) {
      const map = {'1': 'blue', '2': 'green', '3': 'orange', '4': 'purple'};
      return map[type] || 'default';
    },

    async getTableData() {
      this.tableLoading = true;
      try {
        const res = await this.api.feeRulepageApi({
          ...this.paramsData,
          pageNo: this.pagination.pageNo,
          pageSize: this.pagination.pageSize,
        });
        if (res.code === 200) {
          this.tableData = res.data.records || [];
          this.pagination.total = res.data.total || 0;
        } else {
          this.$message.warning(res.info || "获取数据失败");
        }
      } catch (error) {
        console.error("获取数据失败:", error);
        this.$message.error("获取数据失败");
      } finally {
        this.tableLoading = false;
      }
    },

    handleQuery() {
      this.pagination.pageNo = 1;
      this.getTableData();
    },

    handleReset() {
      this.paramsData = {
        feeNo: "",
        feeName: "",
        feeType: undefined,
      };
      this.pagination.pageNo = 1;
      this.getTableData();
    },

    addBtn() {
      this.$router.push({path: '/base/feeRuleDetail', query: {mode: 'add'}});
    },

    editBtn(record) {
      this.$router.push({path: '/base/feeRuleDetail', query: {id: record.id, mode: 'edit'}});
    },

    async viewBtn(record) {
      try {
        const res = await this.api.feeRuleDetailsApi(record.id);
        if (res.code === 200 && res.data) {
          this.viewData = res.data;
          this.viewModalVisible = true;
        } else {
          this.$message.warning(res.info || "获取详情失败");
        }
      } catch (error) {
        console.error("获取详情失败:", error);
        this.$message.error("获取详情失败");
      }
    },

    async handleDelete(record) {
      try {
        const res = await this.api.feeRuledeleteApi([record.id]);
        if (res.code === 200) {
          this.$message.success('删除成功');
          this.getTableData();
        } else {
          this.$message.warning(res.info || '删除失败');
        }
      } catch (error) {
        console.error("删除失败:", error);
        this.$message.error("删除失败");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.selectBox {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 16px;

  .item {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    margin-right: 20px;

    span {
      margin-right: 8px;
      white-space: nowrap;
    }

    .ant-input {
      width: 200px;
    }

    .ant-select {
      width: 200px;
    }
  }
}

.tableBox {
  margin-bottom: 20px;

  .handleBtn {
    margin-bottom: 16px;

    .ant-btn {
      margin-right: 8px;
    }
  }
}

.pagination-wrapper {
  display: flex;
  justify-content: center;
  margin-top: 16px;
  padding: 12px 0;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-top: none;
  border-radius: 0 0 6px 6px;
}

.detailBox {
  padding: 10px;
}
</style>
